import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import Price from '../Price.js';

const UnitPrice = (_param)=>{
    var { amount , currencyCode , className , fixedDecimals  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "amount",
        "currencyCode",
        "className",
        "fixedDecimals"
    ]);
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("span", swcHelpers.extends({
        className: classnames('unit-price', className)
    }, rest), /*#__PURE__*/ React.createElement(Price, {
        value: amount,
        currency: currencyCode,
        fixedDecimals: fixedDecimals,
        centAmount: true
    }), "/", getLabel('products.unit.metric.liter.abbr'));
};
var UnitPrice$1 = UnitPrice;

export { UnitPrice$1 as default };
//# sourceMappingURL=UnitPrice.js.map
